<template>
  <b-table
    responsive
    :items="tokenHolders"
    :fields="fields"
    class="mb-0 scan-result-table"
  >
    <template #cell(Phone)="data">
      <span class="text-nowrap">
        {{ data.value }}
      </span>
    </template>

    <template #cell(percentage)="data">
      <div class="text-right">{{ data.value }} %</div></template
    >

    <!-- Optional default data cell scoped slot -->
    <template #cell()="data">
      {{ data.value }}
    </template>
  </b-table>
</template>

<script>
// import ResultDialog from './ResultDialog.vue'
import { BTable } from "bootstrap-vue";

export default {
  components: {
    BTable
  },
  props: ["tableData", "tableName"],
  data() {
    return {
      tokenHolders: [],
      fields: [
        {
          key: "rank",
          label: "Rank"
        },
        {
          key: "address",
          label: "Address"
        },
        {
          key: "quantity",
          label: "Quantity"
        },
        {
          key: "percentage",
          label: "Percentage",
          thClass: "text-right percentage-col"
        }
      ],
      items: [
        {
          id: "1",
          first_name: "Marybelle",
          last_name: "Della Scala",
          email: "mdellascala0@opensource.org",
          gender: "Female",
          ip_address: "85.254.7.181",
          Phone: "+86 350 673 7985",
          Country: "China"
        },
        {
          id: "2",
          first_name: "Octavia",
          last_name: "Tohill",
          email: "otohill1@google.co.jp",
          gender: "Female",
          ip_address: "93.70.144.212",
          Phone: "+63 938 283 0018",
          Country: "Philippines"
        },
        {
          id: "3",
          first_name: "Jennie",
          last_name: "Geroldi",
          email: "jgeroldi2@slideshare.net",
          gender: "Female",
          ip_address: "76.145.147.212",
          Phone: "+81 235 674 0110",
          Country: "Japan"
        },
        {
          id: "4",
          first_name: "Vanya",
          last_name: "Wharby",
          email: "vwharby3@mozilla.org",
          gender: "Male",
          ip_address: "139.234.247.155",
          Phone: "+30 349 556 7375",
          Country: "Greece"
        },
        {
          id: "5",
          first_name: "Olenka",
          last_name: "Brawley",
          email: "obrawleyc@adobe.com",
          gender: "Female",
          ip_address: "166.183.163.155",
          Phone: "+62 841 824 0990",
          Country: "Indonesia"
        }
      ],

      series: [],
      chartOptions: {
        chart: {
          width: 380,
          type: "pie"
        },
        labels: [],
        responsive: [
          {
            breakpoint: 480,
            options: {
              chart: {
                width: 200
              },
              legend: {
                position: "bottom"
              }
            }
          }
        ]
      }
    };
  },
  created() {
    //get the token holders data list
    let tokenHoldersData = this.tableData[1].result;
    this.results = tokenHoldersData || [];

    //map only first 10 token data
    if (this.results.length > 0) {
      for (let i = 0; i < 10; i++) {
        this.tokenHolders.push(this.results[i]);
      }
    }
  },
  methods: {
    resultView(get_value) {
      this.results = [];
      this.model_open = true;
      if (get_value.length > 10) {
        for (let index = 0; index < 10; index++) {
          this.results.push(get_value[index]);
        }
      } else {
        get_value.forEach((element) => {
          this.results.push(element);
        });
      }
      //   this.results = get_value;

      // this.results.forEach((value) => {
      //   this.series.push(value.percentage);
      //   this.chartOptions.labels.push(value.address);
      //   // this.labels.push(value.percentage);
      // });
      //     this.results.forEach((value) => {
      //       // this.series.push(value.percentage);
      //       this.chartOptions.labels.push(value.address);
      //     });
      //   //   console.log("results",this.results);
      this.setChart();
    },
    setChart() {
      this.results.forEach((value) => {
        this.series.push(value.percentage);
        this.chartOptions.labels.push(value.percentage);
        // this.labels.push(value.percentage);
      });
    }
  }
};
</script>

<style>
.scan-result-table td {
  padding-left: 10px !important;
}

.scan-result-table th {
  padding: 0px 5px 0px 5px !important;
}

.scan-result-table {
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */
}

.scan-result-table::-webkit-scrollbar {
  display: none;
}
.percentage-col {
  padding-right: 5px !important;
}
</style>
